import { Box } from '@medely/web-components';
import React from 'react';
import ChatMenu from '../Chat';
import ApplicationHeaderHelpIcon from '../ApplicationHeaderHelpIcon';
import ApplicationHeaderLogout from '../ApplicationHeaderLogout';
import { useIsApplicationVideoHeader } from '../useIsApplicationVideoHeader';
import TopBarMobileNavigation from './TopBarMobileNavigation';
import TopBarMobileTitle from './TopBarMobileTitle';
import { useAssignmentContext, useWebView } from '@mp';
import { AssignmentFavoriteButton } from '@mp/components/AssignmentFavoriteButton';

const TopBarMobile = (): React.ReactElement | null => {
  const { isWebView } = useWebView();
  const { assignment } = useAssignmentContext();
  const isApplicationVideoHeader = useIsApplicationVideoHeader();

  if (isWebView) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {!isApplicationVideoHeader && <TopBarMobileNavigation />}
        <TopBarMobileTitle />
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        {assignment && (
          <AssignmentFavoriteButton iconSize="md" assignment={assignment} isIconOnly />
        )}
        {isApplicationVideoHeader ? (
          <>
            <ApplicationHeaderHelpIcon />
            <ApplicationHeaderLogout />
          </>
        ) : (
          <ChatMenu />
        )}
      </Box>
    </Box>
  );
};

export default TopBarMobile;
